import { render } from "./BookBoardEntryUpdate.vue?vue&type=template&id=09ebf525"
import script from "./BookBoardEntryUpdate.vue?vue&type=script&lang=js"
export * from "./BookBoardEntryUpdate.vue?vue&type=script&lang=js"

import "./BookBoardEntryUpdate.vue?vue&type=style&index=0&id=09ebf525&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__